import { Link } from 'react-router-dom';
import sailboatImage from '../assets/404-sailboat.png';
import { useState } from 'react';

// Склонение слова "раз": 1/21/31 раз, 2-4/22-24 раза, 5-20/25-30 раз...
function pluralRaz(n) {
  const mod100 = n % 100;
  const mod10 = n % 10;
  if (mod100 >= 11 && mod100 <= 14) return 'раз';
  if (mod10 === 1) return 'раз';
  if (mod10 >= 2 && mod10 <= 4) return 'раза';
  return 'раз';
}

// Варианты морской путаницы — при каждом заходе на страницу выбирается случайный.
// Чтобы добавить новый вариант со своей картинкой: импортируйте изображение выше
// и добавьте объект { first, repeat, image } в массив ниже.
const VARIANTS = [
  { first: 'Похоже геннакер намотался', repeat: 'Геннакер намотался уже', image: sailboatImage },
  { first: 'Похоже брасы намотались',   repeat: 'Брасы намотались уже',   image: sailboatImage },
  { first: 'Похоже фалы намотались вокруг мачты', repeat: 'Фалы намотались вокруг мачты уже', image: sailboatImage },
  { first: 'Похоже шкоты запутались',   repeat: 'Шкоты запутались уже',   image: sailboatImage },
];

const NotFound = () => {
  const [variant] = useState(() => VARIANTS[Math.floor(Math.random() * VARIANTS.length)]);
  const [windsCount, setWindsCount] = useState(404);
  const handleSailClick = () => {
    setWindsCount(prev => prev + 1);
  };
  return (
    <main style={{
      textAlign: 'center',
      padding: '50px 20px',
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{ fontSize: '1.5rem'}}>
        {windsCount === 404 ? variant.first : variant.repeat}
        <h1 style={{ fontSize: '3rem'}}>{windsCount}</h1>
        {` ${pluralRaz(windsCount)}${windsCount === 404 ? '.' : '!'}`}
      </div>
      <p>
        Такой страницы не существует.<br />
        Или Вы балуетесь
      </p>
      <img
        src={variant.image}
        onClick={handleSailClick}
        alt="Парусник"
        style={{ width: '200px' }}
        title="Намотать еще раз!"
      />
      <Link
        to="/"
        style={{
          padding: '12px 24px',
          backgroundColor: '#edd51b',
          color: 'black',
          textDecoration: 'none',
          borderRadius: '4px',
          fontSize: '1.1rem'
        }}
      >
        Вернуться на главную
      </Link>
    </main>
  );
};

export default NotFound;
